import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationsEN from './en/en.json';
import translationsAR from './ar/ar.json';

const resources = {
  en: {
    translation: translationsEN,
  },
  ar: {
    translation: translationsAR,
  },
};
if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'ar');
}
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    // lng: 'ar',
    lng: localStorage.getItem('i18nextLng') || 'ar',
    fallbackLng: 'ar',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
